import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { IoCloseCircle } from 'react-icons/io5';
import { PATH_NAME } from '../../configs/pathName';
import { ISearchInput } from '../../interfaces/components/input.interface';
import { SearchIcon } from '../elements/svgIcon/outlined';

const SearchInput: React.FC<ISearchInput> = ({
  className,
  icon,
  name,
  isObject,
  setValue,
  value,
  placeholder,
  onFocus = () => {},
  callBackAfterSubmit,
  /* 
    pathname: check if equal to router.pathname to redirect when click clear icon. 
              Because searchInput is used in many page but only redirect when clear input on certain page
    redirectAfterEnter to replace [gid] to groupId and pass it to router.push
  */
  pathname = PATH_NAME.HOME_FEED_SEARCH,
  redirectAfterClear = PATH_NAME.HOME_FEED_SEARCH,
  redirectAfterEnter = PATH_NAME.HOME_FEED_SEARCH,
}) => {
  const router = useRouter();
  const inputRef = useRef<HTMLInputElement>(null);
  const handleClearSearchInput = () => {
    setValue('');
    if (router.pathname === pathname && router.query?.searchKey !== undefined) {
      router.push({
        pathname: redirectAfterClear,
      });
    }
  };
  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
        // callMyFunction();
        // router.push(`${PATH_NAME.HOME_FEED_SEARCH}?${SEARCH_QUERY}=${value}`);
        router.push({
          pathname: redirectAfterEnter,
          query: {
            searchKey: value,
          },
        });
      }
    };
    const input = inputRef?.current;
    input && input.addEventListener('keydown', listener);
    return () => {
      input && input.removeEventListener('keydown', listener);
    };
  }, [inputRef, router, value]);
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (value.trim().length === 0) return;
        // addHistorySearch(value);
        // router.push(`${PATH_NAME.SEARCH}?${SEARCH_QUERY}=${value}`);
        callBackAfterSubmit && callBackAfterSubmit();
      }}
      onClick={(e) => e.preventDefault()}
      className={`${className} bg-[#F1F1F1] w-full px-4 py-1 sm:py-2 border border-[rgba(191, 191, 191, 0.3)] focus-within:border-sky-500 rounded-lg flex items-center justify-start relative z-[90]`}
    >
      <div className="flex-1 flex items-center pr-2">
        <input
          ref={inputRef}
          onFocus={onFocus}
          maxLength={256}
          name={name || ''}
          onChange={(e) => {
            isObject
              ? setValue(e.target.name, e.target.value)
              : setValue(e.target.value);
          }}
          className={` focus:outline-none flex-1 ${
            value == '' ? 'text-grey_2' : 'text-black'
          } bg-transparent text-base`}
          placeholder={placeholder}
          value={value}
        />
        {value && (
          <IoCloseCircle
            onClick={handleClearSearchInput}
            color="#979797"
            className="cursor-pointer"
          />
        )}
      </div>
      <div className="flex">
        <div className="h-[inherit] w-[1px] bg-[rgba(0,0,0,0.12)] overflow-hidden"></div>
        <button type="submit">
          <SearchIcon color="#707070" className="block ml-4 mr-0" />
        </button>
      </div>
    </form>
  );
};

export default SearchInput;
